// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import styles from './styles';
import Button from '../../../common/forms/Button';

type Props = {
  showMessage: string,
  handleClose: Function,
};

export default function ImprovedAlert({ showMessage, handleClose }: Props): React.Node {
  if (!showMessage) {
    return null;
  }

  return (
    <div className="wrapper">
      <div className={`alert ${showMessage}`}>
        <p>
          <FormattedMessage {...messages.alertUpdated} />
        </p>
        <Button
          type="button"
          title={<FormattedMessage {...messages.close} />}
          color="white"
          size="small"
          onClick={handleClose}
        />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/Serp/components/ImprovedAlert/index.js